export type ForemanDetailedSummarySource =
  | 'foremanApp'
  | 'sparta'
  | 'viewpoint';
export type ForemanDetailedSummaryRecordType =
  | 'labor'
  | 'travel'
  | 'perDiem'
  | 'equipment';

export interface ForemanDetailedSummary {
  dateFrom: string;
  dateTo: string;
  records: ForemanDetailedSummaryRecord[];
}

export interface ForemanDetailedSummaryRecord {
  source: ForemanDetailedSummarySource;
  recordType: ForemanDetailedSummaryRecordType;
  workDate: string;
  displayName: string;
  employeeName: string;
  workOrder: string;
  shiftLabel: string;
  foremanCrew: string;
  earnCode: string | null;
  hours: number | null;
  travelHours: number | null;
  equipmentHours: number | null;
  hasPerDiem: boolean;
  perDiemCount: number;
  exportStatus: string | null;
  exportMessage: string | null;
}
